import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.951,4.758,8.332,2.091a.662.662,0,0,0-.664,0L3.049,4.758a.663.663,0,0,0-.333.575v5.334a.663.663,0,0,0,.333.575l4.619,2.667a.664.664,0,0,0,.664,0l4.619-2.667a.663.663,0,0,0,.333-.575V5.333A.663.663,0,0,0,12.951,4.758ZM8,3.434l3.516,2.029-3.434,2L4.5,5.454Zm0,9.132L4.045,10.283V6.214L7.869,8.362a.326.326,0,0,1,.1.164v4.049Z';
const draw24px =
  'M20.535,7.464a.734.734,0,0,0-.091-.338v0a.735.735,0,0,0-.248-.248c-.01-.006-.015-.019-.026-.026l-7.794-4.5a.755.755,0,0,0-.75,0L3.831,6.85c-.011.007-.016.02-.026.026a.735.735,0,0,0-.248.248v0a.734.734,0,0,0-.091.338c0,.013-.009.023-.009.036v9a.748.748,0,0,0,.375.649l7.794,4.5c.011.007.024,0,.036.01a.677.677,0,0,0,.678,0c.012-.006.025,0,.036-.01l7.794-4.5a.748.748,0,0,0,.375-.649v-9C20.544,7.487,20.535,7.477,20.535,7.464ZM12,3.866,18.294,7.5,12,11.134,5.706,7.5ZM4.956,8.8l6.294,3.634V19.7L4.956,16.067Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const AddBoxIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'addBox'),
) as IconWithRender;

AddBoxIcon.displayName = 'AddBoxIcon';
AddBoxIcon.propTypes = Icon.propTypes;
AddBoxIcon.renderIcon = (props) => <AddBoxIcon {...props} />;
export default AddBoxIcon;
